import { FunctionComponent } from 'react';
import './styles/DanceSchoolSwitcherModal.scss';

import { Stack, Typography } from '@mui/material';
import { Add, ArrowForward } from '@mui/icons-material';

import { Avatar, Modal, ProgressSpinner } from '@dw/components/core';
import { useGetMyDanceSchools } from '@dw/hooks/api/DanceSchoolApi';
import { IDanceSchool } from '@dw/models/danceSchool';
import { useAuth, useBinaryToggle } from '@dw/hooks';
import { useSwitchSchoolsMutation } from '@dw/hooks/api/AuthApi';

import { CreateNewDanceSchoolModal } from './CreateNewDanceSchoolModal';

interface IDanceSchoolSwitcherModalProps {
  open: boolean;
  onClose: () => void;
}
export const DanceSchoolSwitcherModal: FunctionComponent<IDanceSchoolSwitcherModalProps> = (props: IDanceSchoolSwitcherModalProps) => {

  const {
    open,
    onClose
  } = props;

  const { danceSchool } = useAuth();

  const { isOpen: createDanceSchoolOpen, toggle: toggleCreateDanceSchoolOpen } = useBinaryToggle();

  const { data: myDanceSchools } = useGetMyDanceSchools();

  const { mutate: switchSchools, isPending: switchSchoolsLoading, variables: switchSchoolsVariables } = useSwitchSchoolsMutation({
    onSuccess: () => {
      onClose();
    }
  });

  const handleSwitchSchools = (school: IDanceSchool) => {
    if (danceSchool?.id === school.id) {
      onClose();
      return;
    }

    switchSchools({
      danceSchoolId: school.id
    });
  }

  const handleCreateNewDanceSchool = () => {
    onClose();
    toggleCreateDanceSchoolOpen();
  }

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title='Switch Dance Schools'
      >
        {!myDanceSchools ? (
          <Stack justifyContent='center' alignItems='center' padding={5}>
            <ProgressSpinner />
          </Stack>
        ) : (
          <Stack className='dw-school-switcher-modal'>
            {myDanceSchools.map(school => (
              <Stack
                key={school.id}
                direction='row'
                justifyContent='space-between'
                alignItems='center'
                className='school-option pointer hover-background'
                onClick={() => handleSwitchSchools(school)}
              >
                <Stack direction='row' alignItems='center' columnGap={1}>
                  {school.logoKey && (
                    <Avatar imageKey={school.logoKey} size='tiny' shape='square' />
                  )}
                  <Typography variant='body2'>{school.name}</Typography>
                </Stack>

                {danceSchool?.id === school.id ? (
                  <Typography variant='body2' fontWeight={600} color='primary'>Current</Typography>
                ) : switchSchoolsLoading && switchSchoolsVariables?.danceSchoolId === school.id ? (
                  <ProgressSpinner size={20} />
                ) : (
                  <ArrowForward />
                )}
              </Stack>
            ))}

            <Stack
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className='school-option pointer hover-background'
              onClick={handleCreateNewDanceSchool}
            >
              <Typography variant='body1'>Create New School</Typography>

              <Add />
            </Stack>
          </Stack>
        )}
      </Modal>
    
      <CreateNewDanceSchoolModal
        open={createDanceSchoolOpen}
        onClose={toggleCreateDanceSchoolOpen}
      />
    </>
  )
}